import { FormGroup as BSFormGroup } from 'react-bootstrap'
import styled from 'styled-components'

import CardContainer from 'live/components/ui/CardContainer'

export const FormGroup = styled(BSFormGroup)`
    flex: 1;
    margin: 0;

    > label {
        margin: 0 !important;
    }

    > input {
        width: 100%;
        font-size: 12px;
        height: 42px;
        margin: 0 !important;
        border-top: 1px solid ${({ theme }) => theme['gray-200']};
    }

    &.has-error {
        .Select-control {
            border-color: #a94442;
            box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
        }
    }
`

export const FieldRow = styled.div`
    display: flex;
    align-items: center;
    border-top: 1px solid ${({ theme }) => theme['gray-200']};
    align-items: stretch;
`

export const FieldSetFooter = styled.footer`
    border-top: 1px solid ${({ theme }) => theme['gray-200']};
    background-color: ${({ theme }) => theme['gray-200']};
    padding-bottom: 12px;
    display: flex;
    justify-content: space-between;

    > div.action-buttons {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;

        .or {
            padding-left: 12px;
            margin: 0;
            display: flex;
            align-items: center;
            justify-content: center;
        }

        .box-orient.btn-link {
            margin: 0;
            padding: 0;
        }
    }
`

export const FieldSetStyledContainer = styled(CardContainer).attrs({
    subtitle: '',
    stickyControls: false,
    collapsed: false
})<{ editing?: boolean }>`
    position: relative;
    padding: 0;
    margin: 0;
    box-shadow: none;

    border: 1px solid ${({ theme, editing }) => (editing ? theme['blue-500'] : theme['gray-400'])};

    > header {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        background: ${({ theme, editing }) => (editing ? theme['gray-200'] : theme['gray-0'])};

        > div:first-of-type {
            text-transform: uppercase;
        }
    }

    > footer {
        border-bottom-left-radius: 4px;
        border-bottom-right-radius: 4px;
    }

    > header,
    > footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 16px;
    }

    .form-group {
        margin: 0;
        padding: 8px 16px;

        &:not(:last-of-type) {
            border-right: 1px solid ${({ theme }) => theme['gray-200']};
        }
    }

    .form-group {
        > input {
            border: none;
            background: none;
            box-shadow: none;
        }
    }

    fieldset[disabled] {
        .Select-control {
            border: none;
            background: none;
            box-shadow: none;

            .Select-arrow-zone,
            .Select-clear-zone {
                display: none;
            }
        }

        .form-group {
            > input {
                border: none;
                background: none;
                box-shadow: none;
                color: ${({ theme }) => theme['gray-1000']};
            }
        }
    }
`
